"use client"
import React, { useState } from "react";
import {
  Form,
  Button,
  FormControl,
  Alert,
  Container,
  Row,
  Col
} from "react-bootstrap";
import useApi from "@/components/api/useApi";
import { Formik } from "formik";

import "@/components/login/InlineSignupForm.css";
import ReCAPTCHAv3Button from "@/components/shared/RcCAPTCHAv3Button";

let yup = require("yup");
const postalCodes = require("postal-codes-js");

yup.addMethod(yup.string, "validPostalCode", function() {
  return this.test({
    name: "validPostalCode",
    message: "Please enter a valid postal code.",
    test: (postalCode = "") => {
      return postalCodes.validate("us", postalCode) === true;
    }
  });
});

const InlineSignupForm = ({
  name,
  showHeading,
  heading,
  text,
  type,
  state,
  lookup,
  onRegistrationComplete,
  overrideApproveComponent
}) => {
  const [activateProfile, setActivateProfile] = useState(false);
  const [registerFailed, setRegisterFailed] = useState(false);
  const api = useApi();
  const randomNumber = api.getRandomInt(10000, 99999);

  const registerCall = (values, setSubmitting) => {
    var payload = {
      ...values,
      givenName: values.primaryPOC.firstName,
      familyName: values.primaryPOC.lastName,
      emailAddress: values.primaryPOC.emailAddress
    };
    api
      .registerNewCommunityProfile(name, payload)
      .then(response => {
        setSubmitting(false);
        setActivateProfile(true);
        if (onRegistrationComplete) {
          onRegistrationComplete(response);
        }
      })
      .catch(error => {
        // TODO what to do if this fails
        setSubmitting(false);
        setRegisterFailed(true);
      });
  };

  var registerSchema = yup.object({
    primaryPOC: yup.object({
      firstName: yup
        .string()
        .required()
        .label("First Name")
    }),
    userProfileType: yup
      .string()
      .required()
      .label("Type")
  });

  if (type === "VOLUNTEER" || type === "AMBASSADOR") {
    registerSchema = yup.object({
      primaryPOC: yup.object({
        firstName: yup
          .string()
          .required()
          .label("First Name"),
        lastName: yup
          .string()
          .required()
          .label("Last Name"),
        emailAddress: yup
          .string()
          .required()
          .email()
          .label("Email Address")
      }),
      userProfileType: yup
        .string()
        .required()
        .label("Type"),
      postalCode: yup
        .string()
        .required()
        .validPostalCode()
        .label("Postal Code")
    });
  }

  const values = {
    primaryPOC: {
      firstName: "",
      lastName: "",
      emailAddress: ""
    },
    userProfileType: type,
    state: state,
    lookup: lookup
  };

  return (
    <>
      <div className="inline-signup-form">
        <Formik
          initialValues={values}
          validationSchema={registerSchema}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              registerCall(values, setSubmitting);
            }, 400);
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            isSubmitting,
            isValid,
            values,
            touched,
            errors,
            setFieldValue,
            submitForm
          }) => (
            <Form className="no-style" onSubmit={handleSubmit}>
              <Container>
                <Row>
                  <Col>
                    {showHeading && (
                      <h4>
                        {heading ? heading : "Let's create your account."}
                      </h4>
                    )}
                    <p style={{ marginBottom: 20 }}>
                      {text ??
                        "Please provide the following information and we'll send you an email with a link to activate your account."}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {!registerFailed && !activateProfile && (
                      <>
                        <div
                          className="form-group"
                          id="validationFormikFirstName"
                        >
                          <Form.Label bsPrefix="form-label required">
                            First Name
                          </Form.Label>
                          <FormControl
                            name="primaryPOC.firstName"
                            value={values.primaryPOC.firstName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              !!errors.primaryPOC &&
                              !!errors.primaryPOC.firstName &&
                              touched.primaryPOC &&
                              touched.primaryPOC.firstName
                            }
                            placeholder="First Name"
                          />
                          {errors.primaryPOC &&
                          errors.primaryPOC.firstName &&
                          touched.primaryPOC &&
                          touched.primaryPOC.firstName ? (
                            <Form.Control.Feedback type="invalid">
                              {errors.primaryPOC.firstName}
                            </Form.Control.Feedback>
                          ) : null}
                        </div>
                        <div
                          className="form-group"
                          id="validationFormikLastName"
                        >
                          <Form.Label bsPrefix="form-label required">
                            Last Name
                          </Form.Label>
                          <FormControl
                            name="primaryPOC.lastName"
                            value={values.primaryPOC.lastName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              !!errors.primaryPOC &&
                              !!errors.primaryPOC.lastName &&
                              touched.primaryPOC &&
                              touched.primaryPOC.lastName
                            }
                            placeholder="Last Name"
                          />
                          {errors.primaryPOC &&
                          errors.primaryPOC.lastName &&
                          touched.primaryPOC &&
                          touched.primaryPOC.lastName ? (
                            <Form.Control.Feedback type="invalid">
                              {errors.primaryPOC.lastName}
                            </Form.Control.Feedback>
                          ) : null}
                        </div>
                        <div
                          className="form-group"
                          id="validationFormikEmailAddress"
                        >
                          <Form.Label bsPrefix="form-label required">
                            Email Address
                          </Form.Label>
                          <FormControl
                            type="email"
                            name="primaryPOC.emailAddress"
                            value={values.primaryPOC.emailAddress}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              !!errors.primaryPOC &&
                              !!errors.primaryPOC.emailAddress &&
                              touched.primaryPOC &&
                              touched.primaryPOC.emailAddress
                            }
                            placeholder="Email Address"
                          />
                          {errors.primaryPOC &&
                          errors.primaryPOC.emailAddress &&
                          touched.primaryPOC &&
                          touched.primaryPOC.emailAddress ? (
                            <Form.Control.Feedback type="invalid">
                              {errors.primaryPOC.emailAddress}
                            </Form.Control.Feedback>
                          ) : null}
                        </div>
                        <div
                          className="form-group"
                          id="validationFormikPostalCode"
                        >
                          <Form.Label bsPrefix="form-label required">
                            Postal Code
                          </Form.Label>
                          <FormControl
                            name="postalCode"
                            value={values.postalCode}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              !!errors.postalCode && touched.postalCode
                            }
                            placeholder="Postal Code"
                          />
                          {errors.postalCode && touched.postalCode ? (
                            <Form.Control.Feedback type="invalid">
                              {errors.postalCode}
                            </Form.Control.Feedback>
                          ) : null}
                        </div>
                        <ReCAPTCHAv3Button
                          action={"inlineSignup"}
                          style={{
                            marginTop: 24,
                            width: 240,
                            marginTop: "1.5rem"
                          }}
                          onVerify={success => {
                            if (success) {
                              submitForm();
                            }
                          }}
                          disabled={!isValid || isSubmitting}
                        >
                          Create Account
                        </ReCAPTCHAv3Button>
                        <p style={{ marginTop: 20 }}>
                          By signing up, you agree to our{" "}
                          <a href="https://urality.com/tou">Terms of Use</a> and{" "}
                          <a href="https://urality.com/privacy">
                            Privacy Policy
                          </a>
                        </p>
                      </>
                    )}
                    {registerFailed && !activateProfile && (
                      <div className="center-child-div-parent">
                        <Alert variant="danger" bsPrefix="signup-alert">
                          <Alert.Heading>Uh oh!</Alert.Heading>
                          <p>
                            Something went wrong with registration. Please try
                            again later.
                          </p>
                        </Alert>
                      </div>
                    )}
                    {!registerFailed && activateProfile && (
                      <div className="center-child-div-parent">
                        {overrideApproveComponent ? (
                          <>{overrideApproveComponent}</>
                        ) : (
                          <Alert variant="success" bsPrefix="signup-alert">
                            <Alert.Heading>Great!</Alert.Heading>
                            <p>
                              You should receive an activation link shortly.
                              Please click on that link to activate your
                              account.
                            </p>
                          </Alert>
                        )}
                      </div>
                    )}
                  </Col>
                </Row>
              </Container>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default InlineSignupForm;
